import { useEffect } from 'react';
import styled from 'styled-components';
import StyledLink from '../../../../shared/components/global/StyledLink';
import HighlightJobsSwiper from '../../../../shared/components/job/HighlightJobsSwiper';
import JobCard from '../../../../shared/components/job/JobCard';
import { Button, ButtonSizes } from '../../../../shared/styles/button';
import { Container, ContainerContentFull, ContainerContentStandard } from '../../../../shared/styles/container';
import Layout from '../../components/global/Layout';
import Seo from '../../components/global/Seo';
import JobsCommonSearches from '../../components/jobs/JobsCommonSearches';
import JobsHeroHeader from '../../components/jobs/JobsHeroHeader';
import JobsSearchbar from '../../components/jobs/JobsSearchbar';
import { TopCompanies } from '../../components/jobs/TopCompanies';
import { BUCKET_URL } from '../../model/S3Bucket';
import { CompanyOperation } from '../../redux/companiesSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchJobsAsync, selectJobs } from '../../redux/jobsSlice';

const CompaniesSearch = styled.article`
    padding-top: 96px;
    padding-bottom: 32px;
    min-height: 100vh;
    h1 {
        font-weight: 700;
        font-size: 36px;
        line-height: 49px;
        margin-top: 0;
        margin-bottom: 32px;
        text-align: center;
    }
`;

const JobCardList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .job-card {
        margin-bottom: 16px;
    }
`;
const MoreJobsContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
`;
const SearchbarOuterContainer = styled.div`
  position: relative;
  margin-bottom: 30px;
`;

const JobsPage = () => {

    const dispatch = useAppDispatch()
    const allJobs = useAppSelector(selectJobs)

    const fetchData = async (token, operation) => {
        const nowISODate = new Date().toISOString();
        const filter = {};
        filter['expiresAt'] = { gte: nowISODate }
        const variables = {
            nextToken: token,
            operation: operation,
            filter: filter
        };
        await dispatch(fetchJobsAsync(variables))
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        if (allJobs == null) {
            fetchData(null, CompanyOperation.INITIAL);
        }

    }, [dispatch, allJobs])

    const getTopJobs = () => allJobs != null ? allJobs?.filter((job) => job.isHighlight) : [];

    const title = 'Jobs entdecken';
    const description = 'Entdecke die Jobs vom easyboarding';
    return (
        <>
            <Seo title={title} description={description} />
            <Layout preview={false}>
                <Container backgroundColor='#FAFAFA'>
                    <ContainerContentFull>
                        <JobsHeroHeader small={false} />
                    </ContainerContentFull>
                </Container>
                <Container backgroundColor='#f5f5f7'>

                    <ContainerContentStandard>
                        <SearchbarOuterContainer>
                            <JobsSearchbar top={"-30px"} />
                        </SearchbarOuterContainer>
                    </ContainerContentStandard>

                </Container>
                <Container backgroundColor='#f5f5f7' overflow='hidden'>
                    <ContainerContentStandard>
                        <CompaniesSearch>
                            {getTopJobs() != null && getTopJobs()?.length > 0 &&
                                <div>
                                    <h1>Highlight Jobs</h1>
                                    <HighlightJobsSwiper topJobs={getTopJobs()} bucketUrl={BUCKET_URL} />
                                </div>
                            }
                            <JobsCommonSearches />
                            {allJobs != null && allJobs?.length > 0 &&
                                <TopCompanies jobs={allJobs} />
                            }
                            {allJobs != null && allJobs?.length > 0 &&
                                <div>
                                    <h1>Aktuelle Jobs</h1>
                                    <JobCardList>
                                        {allJobs?.map((job, index) => {
                                            return (
                                                <StyledLink key={job?.title + index} href={`/jobs/${job.slug}`}>
                                                    <JobCard job={job} smallCard={false} bucketUrl={BUCKET_URL} />
                                                </StyledLink>
                                            )
                                        })}
                                    </JobCardList>
                                    <MoreJobsContainer>
                                        <StyledLink href="/jobs/search">
                                            <Button primary size={ButtonSizes.m}>Mehr Jobs entdecken</Button>
                                        </StyledLink>
                                    </MoreJobsContainer>
                                </div>
                            }
                        </CompaniesSearch>

                    </ContainerContentStandard>
                </Container>
            </Layout >
        </>
    )
}

export default JobsPage;

/* export async function getServerSideProps(context) {
    const { req: { headers, url }, res } = context;
    return {
        props: {
            //agentur
        },
    };
}
 */